import '../sass/carousel.scss';

(() => {
    const swiperScript = document.querySelector('#icrav-2027-swiper-js');
    const $blocks = document.querySelectorAll('.carousel');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.carousel__carousel');
        const $carouselPagination = $block.querySelector('.carousel__pagination');
        const $carouselNavigationPrev = $block.querySelector('.carousel__navigation-btn--prev');
        const $carouselNavigationNext = $block.querySelector('.carousel__navigation-btn--next');

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                pagination: {
                    el: $carouselPagination,
                    clickable: false,
                },
                keyboard: {
                    enabled: true,
                },
                centeredSlides: true,
                rewind: true,
            });

            if ($carouselNavigationPrev) {
                $carouselNavigationPrev.addEventListener('click', () => {
                    carousel.slidePrev();
                });
            }

            if ($carouselNavigationNext) {
                $carouselNavigationNext.addEventListener('click', () => {
                    carousel.slideNext();
                });
            }
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#icrav-2027-swiper-js');

                console.log(swiperScript);

                if (!swiperScript) return;

                initCarousel();
            });
        }
    });
})();
